module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.data.length
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sync
    }
  }, [_vm._v("Ladda om")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.types), function(v, key) {
    return _c('button', {
      class: (v.active ? 'active' : '') + ' type--' + v.severity,
      on: {
        "click": function($event) {
          return _vm.filterSync(key)
        }
      }
    }, [_vm._v(_vm._s(v.emoji) + " " + _vm._s(v.label))])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.data), function(n) {
    return _c('tbody', {
      class: (n.expanded ? 'expanded ' : ''),
      on: {
        "click": function($event) {
          n.expanded = true
        }
      }
    }, [_c('tr', [_c('td', [_vm._v("#" + _vm._s(n.id))]), _vm._v(" "), _c('td', {
      class: 'type--' + n.severity
    }, [_vm._v(_vm._s(n.emoji) + " " + _vm._s(n.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(JSON.parse(n.context).other.PATH_INFO || JSON.parse(n.context).other.laravel_path))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(JSON.parse(n.exception).subject))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(JSON.parse(n.exception).msg || JSON.parse(n.exception).error)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(n.created_at))])]), _vm._v(" "), (n.expanded) ? _c('tr', [_c('th', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Kontext")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Felväg")])]) : _vm._e(), _vm._v(" "), (n.expanded) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('table', [_vm._l((JSON.parse(n.context)), function(a, b) {
      return (n.context && b !== 'other') ? _c('tr', [_c('th', [_vm._v(_vm._s(b) + ":")]), _c('td', [_vm._v(_vm._s(a))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((JSON.parse(n.context).other), function(a, b) {
      return (n.context) ? _c('tr', [_c('th', [_vm._v(_vm._s(b) + ":")]), _c('td', [_vm._v(_vm._s(a))])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('button', {
      staticClass: "btn white border small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          n.expanded = false
        }
      }
    }, [_vm._v("Stäng")])])])], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      },
      domProps: {
        "innerHTML": _vm._s('<pre>' + (JSON.parse(n.exception).trace || '').replace(/\n/g, '<br>') + '</pre>')
      }
    })]) : _vm._e()])
  })], 2)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Typ")]), _vm._v(" "), _c('th', [_vm._v("Väg")]), _vm._v(" "), _c('th', [_vm._v("Ämne")]), _vm._v(" "), _c('th', [_vm._v("Meddelande/fel")]), _vm._v(" "), _c('th', [_vm._v("Skapad")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b512c79"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Notifications.vue
// module id = 979
// module chunks = 0